const AnalysisContainer = ({children}: any) => {
  return (
    <div className="WayToReport__body__anylasisData__anylasis">
        {children}
    </div>
  )
};

export default AnalysisContainer;
